<div class="row">
  <div class="col-lg-12">
    <div class="card">
      <div class="card-body">


        <div class="divContainer" style="position:relative;top:-30px;">

          <ul class="nav nav-tabs nav-tabs-custom" id="TabulExceptionList">
            <li class="nav-item"><a data-toggle="tab" href="#ExceptionList" class="nav-link active">Exception</a></li>
            <li class="nav-item"><a data-toggle="tab" href="#TrackingList" class="nav-link">Tracking</a></li>
          </ul>


          <div class="row">
            <div class="col-sm-2">
              <label>From</label>
              <input type="date" class="form-control float-right" id="Txt_FromDate" autocomplete="off">
            </div>
            <div class="col-sm-2">
              <label>To</label>
              <input type="date" class="form-control float-right" id="Txt_ToDate" autocomplete="off">
            </div>
            <div class="col-sm-4">
              <br>
              <button type="button" class="btn btn-outline-info waves-effect waves-light" title="Get" (click)="getFiltered()">Search</button>
              <button type="button" class="btn btn-outline-danger waves-effect waves-light" title="Clear" (click)="resetFilter()" style="margin-left:10px;">Reset</button>
            </div>
            <br />
          </div>

          <div class="tab-content">
            <div id="ExceptionList" class="tab-pane active">
              <table #dataTable class="display" style="width:100%" id="reportTable"></table>
            </div>

            <div id="TrackingList" class="tab-pane">
              <div id="divTackingDataList" style="overflow:auto;"></div>
            </div>

          </div>


        </div>


      </div>
    </div>
  </div>
</div>
